// extracted by mini-css-extract-plugin
module.exports = {"meetingProviderTypeIcon":"OnlineMeetingProviderPage_meetingProviderTypeIcon__1VX_L","meetingProviderType":"OnlineMeetingProviderPage_meetingProviderType__3r6Qo"};